import React from 'react'

import { Form, Col, Row, Table } from '_zari/core'

import { EstadosOSE } from 'constants/index'

import * as Cells from './cells'

const ListaDocumentosSection = ({ documentos, clickDocumentoCheck, repetirConsultaDocumentos }) => {
  const checkDocumentoChange = React.useCallback(
    ({ _id }) => {
      clickDocumentoCheck({ _id })
    },
    [clickDocumentoCheck]
  )

  return (
    <>
      <Row>
        <Col md={12} className='px-4 py-2'>
          <Table.ClientSide
            filas={documentos}
            headRows={[
              { label: '', width: 50, align: 'center' },
              { label: 'RUC', width: 110, align: 'center' },
              { label: 'RAZ. SOCIAL', width: 185, align: 'center' },
              { label: 'DOCUMENTO', width: 140, align: 'center' },
              { label: 'EMITIDA', width: 90, align: 'center' },
              { label: 'ENVIO', width: 130, align: 'center' },
              { label: 'CORREO ENV', width: 85, align: 'center' },
              { label: 'CORREO', width: 150, align: 'center' },
              { label: 'ESTADO', width: 110, align: 'center' },
              { label: 'OBS. OSE', width: 110, align: 'center' },
              { label: '', width: 30, align: 'center' }
            ]}
            rowTemplate={row => (
              <Table.Row hover key={row._id}>
                <Table.Cell align='center'>
                  <Form.Checkbox
                    checked={row.checked}
                    onChange={() => checkDocumentoChange({ _id: row._id })}
                    id={`flag-${row._id}`}
                    name={`flag-${row._id}`}
                    label=''
                  />
                </Table.Cell>
                <Table.Cell align='center'>{row.ruc || '--'}</Table.Cell>
                <Table.Cell>{row.razonSocial || '--'}</Table.Cell>
                <Table.Cell align='center'>{`${row.tipoDocumento}-${row.serieDocumento}-${row.numeroDocumento}`}</Table.Cell>
                <Table.Cell align='center'>{row.fechaEmision || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.fechaEnvio || '--'}</Table.Cell>
                <Table.Cell align='center'>{row.flagCorreoEnviado ? 'Si' : 'No'}</Table.Cell>
                <Table.Cell align='center'>{row.correo || '--'}</Table.Cell>
                <Table.Cell align='center'>
                  {row.estadoOSE ? EstadosOSE.__dictionary[row.estadoOSE].nombre : '--'}
                  {row.estadoOSEBaja ? ' / BAJA' : ''}
                </Table.Cell>
                <Table.Cell align='center'>{row.observacionOSE || '--'}</Table.Cell>
                <Cells.OpcionesDropdownCell row={row} repetirConsultaDocumentos={repetirConsultaDocumentos} />
              </Table.Row>
            )}
          />
        </Col>
      </Row>
    </>
  )
}

export default React.memo(ListaDocumentosSection)
